import { environment } from "src/environments/environment";
import { isNullOrUndefined } from "util";
import { OptionHeaderStyleEnum } from '../../enums/option-header-style.enum';
import { ScriptNamesEnum } from "../../enums/script-names-enum";
import * as i0 from "@angular/core";
var CompanyService = /** @class */ (function () {
    function CompanyService() {
    }
    CompanyService.prototype.setCompany = function (company) {
        this.company = company;
    };
    CompanyService.prototype.getCompanyParams = function () {
        try {
            return this.company;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getCode = function () {
        try {
            return this.company.code;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getName = function () {
        try {
            return this.company.name;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getPhone = function () {
        try {
            return this.company.phone;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getInfoEmail = function () {
        try {
            return this.company.infoEmail;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getPrivacy = function () {
        try {
            return this.company.privacyUrl;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getEmail = function () {
        try {
            return this.company.email;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getFooterColor = function () {
        try {
            return this.company.footerColor;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getHeaderColor = function () {
        try {
            return this.company.headercolor;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getMainColor = function () {
        try {
            return this.company.mainColor;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getSecundaryColor = function () {
        try {
            return this.company.secondaryColor;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getLogo = function () {
        try {
            return environment.appResource.companyLogos + this.company.logo;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getWebSite = function () {
        try {
            return this.company.webSite;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getVisibleEcommerce = function () {
        try {
            return this.company.visibleEcommerce;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getVisibleChaterOnly = function () {
        try {
            return this.company.visibleCharterOnly;
        }
        catch (error) {
            return false;
        }
    };
    CompanyService.prototype.getVisiblepago = function () {
        try {
            return this.company.visiblePago;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getTermsConditions = function () {
        try {
            return this.company.privacyUrl;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getListColors = function () {
        try {
            return this.company.headerActions.colorsForMonth;
        }
        catch (error) {
            return [];
        }
    };
    CompanyService.prototype.getFilterByName = function (name) {
        try {
            var auxFilter = void 0;
            auxFilter = this.company.headerActions.filters.find(function (item) { return item.filter === name; });
            return auxFilter.visible;
        }
        catch (error) {
            return false;
        }
    };
    CompanyService.prototype.getIsVisibleColumnPassenger = function (name) {
        try {
            var auxFilter = void 0;
            auxFilter = this.company.headerActions.filters.find(function (item) { return item.filter === name; });
            return auxFilter.visible || this.getVisibleChaterOnly();
        }
        catch (error) {
            return true;
        }
    };
    CompanyService.prototype.getLabelSlogan = function () {
        try {
            return this.company.slogan.label;
        }
        catch (error) {
            return "";
        }
    };
    CompanyService.prototype.getLabelSloganContactUs = function () {
        try {
            return this.company.slogan.labelConctatUs;
        }
        catch (error) {
            return "";
        }
    };
    CompanyService.prototype.getListMenu = function () {
        try {
            return this.company.listadoMenu;
            //        return [
            //   {
            //     "name": "HOME",
            //     "value": "https://www.royalgalapagos.com/"
            //   },
            //   {
            //     "name": "our fleet",
            //     "value": "https://www.royalgalapagos.com/cruise-compare.html"
            //   },
            //   {
            //     "name": "private charters",
            //     "value": "https://www.royalgalapagos.com/cruise-charters.html"
            //   },
            //   {
            //     "name": "cruise deals",
            //     "value": "https://www.royalgalapagos.com/bookings/royal/All/All/2022-All/2"
            //   },
            //   {
            //     "name": "galapagos",
            //     "value": "https://www.royalgalapagos.com/galapagos.html"
            //   },
            //   {
            //     "name": "about us",
            //     "value": "https://www.royalgalapagos.com/ecuador/contact-us.html"
            //   },
            //   {
            //     "name": "contact us",
            //     "value": "https://www.royalgalapagos.com/forms/en/base/3"
            //   }
            // ];
        }
        catch (error) {
            return [];
        }
    };
    CompanyService.prototype.getNumberVisibleOnHold = function () {
        try {
            return isNullOrUndefined(this.company.headerActions.options.numberActiveOnHold)
                ? 6
                : this.company.headerActions.options.numberActiveOnHold;
        }
        catch (error) {
            return 6;
        }
    };
    CompanyService.prototype.getHeaderActions = function () {
        try {
            return this.company.headerActions;
        }
        catch (error) {
            return undefined;
        }
    };
    CompanyService.prototype.getScripts = function () {
        var scripts = [];
        if (this.getHeaderActions().scripts)
            scripts = this.getHeaderActions().scripts.filter(function (searchItem) { return searchItem.name === ScriptNamesEnum.FOR_INITIAL_PAGE; });
        return scripts.map(function (item) {
            return { srcLinks: item.url };
        });
    };
    CompanyService.prototype.getBodyScripts = function () {
        var scripts = [];
        if (this.getHeaderActions().scripts)
            scripts = this.getHeaderActions().scripts.filter(function (searchItem) { return searchItem.name === ScriptNamesEnum.FOR_BODY_PAGE; });
        // scripts = [
        //   { name: "noscirpt", url: "assets/js/google-tag-manager-rg-noscript.js" },
        // ];
        return scripts.map(function (item) {
            return { srcLinks: item.url };
        });
    };
    CompanyService.prototype.getScriptsForThankYouPage = function () {
        var scripts = [];
        if (this.getHeaderActions().scripts)
            scripts = this.getHeaderActions().scripts.filter(function (searchItem) { return searchItem.name === ScriptNamesEnum.FOR_THANK_YOU_PAGE; });
        return scripts.map(function (item) {
            return { srcLinks: item.url };
        });
    };
    CompanyService.prototype.getButtonMenu = function () {
        if (this.getHeaderActions().options) {
            return this.getHeaderActions().options.headerButtonLink
                ? this.getHeaderActions().options.headerButtonLink
                : undefined;
        }
        else {
            return undefined;
        }
    };
    CompanyService.prototype.getOptionHeaderStyle = function () {
        if (this.getHeaderActions().options) {
            return this.getHeaderActions().options.optionHeaderStyle
                ? this.getHeaderActions().options.optionHeaderStyle
                : OptionHeaderStyleEnum.DEFAULT;
        }
        else {
            return OptionHeaderStyleEnum.DEFAULT;
        }
    };
    //TODO: GETTERS PARA MES Y AÑO DE FIND COMPANY
    CompanyService.prototype.getDateRange = function () {
        try {
            return this.company.fechasBusquedaDefault;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.prototype.getWhatsappNumber = function () {
        try {
            return this.company.whatsappNumber;
        }
        catch (error) {
            console.error(error);
        }
    };
    CompanyService.ngInjectableDef = i0.defineInjectable({ factory: function CompanyService_Factory() { return new CompanyService(); }, token: CompanyService, providedIn: "root" });
    return CompanyService;
}());
export { CompanyService };
